// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"a29f836f","856":"d25e5e12"}[chunkId] + ".chunk.js";
};